// Expects a decimal number
export function formatPercentage(number: number) {
  return Number(number).toLocaleString(undefined, { style: "percent", minimumFractionDigits: 2 });
}
